//firebase database
// export const DB_CONFIG = {
//   apiKey: "AIzaSyCM5KGK6wNR6tRMmW6FRXMqpEn54q7zkxA",
//   authDomain: "iotbwater.firebaseapp.com",
//   databaseURL: "https://iotbwater.firebaseio.com",
//   projectId: "iotbwater",
//   storageBucket: "iotbwater.appspot.com",
//   messagingSenderId: "681560185873"
//   };

import app from 'firebase/app';
import 'firebase/firebase-database';
import 'firebase/firebase-auth'
import 'firebase/firebase-performance'
import 'firebase/firebase-analytics'

// import firebase from 'firebase/app';
// import 'firebase/firebase-database';
// import { DB_CONFIG } from '../assets/config';

const DB_CONFIG = {
  apiKey: "AIzaSyCM5KGK6wNR6tRMmW6FRXMqpEn54q7zkxA",
  authDomain: "watertech.web.app",
  databaseURL: "https://iotbwater.firebaseio.com",
  projectId: "iotbwater",
  storageBucket: "iotbwater.appspot.com",
  messagingSenderId: "681560185873",
  appId: "1:681560185873:web:5d465314521690622e65b0",
  measurementId: "G-C2VZSFCJ2T"
};

class Firebase {
  constructor() {
    app.initializeApp(DB_CONFIG);

    this.db = app.database();
    this.perf = app.performance();
    this.anal = app.analytics();
  }
}

export default Firebase;